'use strict'

const device = {}

const ua = navigator.userAgent

const android = !!ua.match(/(Android);?[\s/]+([\d.]+)?/)
const iPad = !!ua.match(/(iPad).*OS\s([\d_]+)/)
const iPhone = !iPad && !!ua.match(/(iPhone\sOS)\s([\d_]+)/)

device.ios = device.android = device.iPhone = device.iPad = device.androidChrome = false

if (android) {
  device.os = 'android'
  device.osVersion = android[2]
  device.android = true
  device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0
}

if (iPad || iPhone) {
  device.os = 'ios'
  device.ios = true
}

if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
  if (device.osVersion.split('.')[0] === '10') {
    device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0]
  }
}

device.webView = () => {
  const rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari/)', 'Android.*(wv|.0.0.0)']
  const regex = new RegExp(`(${rules.join('|')})`, 'ig')

  return Boolean(ua.match(regex))
}

export default device
